<template>
  <header class="fin-topbar">
    <div v-if="loading" class="fin-topbar__status">Cargando...</div>
    <template v-else-if="park">
      <div class="fin-topbar__identity">
        <span class="fin-topbar__title">Finanzas</span>
        <span class="fin-topbar__subtitle">{{ park.name }}</span>
      </div>

      <div class="fin-topbar__center">
        <PeriodSelect
          :model-value="period"
          :months="periods.months"
          :quarters="periods.quarters"
          :current-year="periods.currentYear"
          @update:model-value="$emit('update:period', $event)"
        />

        <button
          class="fin-topbar__compare-btn"
          :class="{ 'fin-topbar__compare-btn--active': comparisonMode }"
          @click="$emit('update:comparisonMode', !comparisonMode)"
        >
          <span class="mdi mdi-compare-horizontal"></span>
          Comparar
        </button>

        <PeriodSelect
          v-if="comparisonMode"
          light
          :model-value="comparisonPeriod"
          :months="periods.months"
          :quarters="periods.quarters"
          :current-year="periods.currentYear"
          @update:model-value="$emit('update:comparisonPeriod', $event)"
        />

        <span v-if="loadingSummary" class="mdi mdi-loading fin-topbar__spinner"></span>
      </div>

      <div class="fin-topbar__right">
        <button class="fin-topbar__report-btn" @click="$emit('generate-report')">
          Exportar reporte
        </button>

        <div class="fin-topbar__divider"></div>

        <GlobalAlertsChip :park-id="park?.id" />
        <NotificationBell :park-id="park?.id" />
      </div>
    </template>
  </header>
</template>

<script setup>
import PeriodSelect from './PeriodSelect.vue'
import NotificationBell from '@/components/Global/NotificationBell.vue'
import GlobalAlertsChip from '@/components/Global/GlobalAlertsChip.vue'

defineProps({
  park: { type: Object, default: null },
  loading: { type: Boolean, default: false },
  periods: { type: Object, default: () => ({ months: [], quarters: [], currentYear: null }) },
  period: { type: String, default: '' },
  comparisonMode: { type: Boolean, default: false },
  comparisonPeriod: { type: String, default: '' },
  loadingSummary: { type: Boolean, default: false },
})

defineEmits(['update:period', 'update:comparisonMode', 'update:comparisonPeriod', 'generate-report'])
</script>

<style scoped>
.fin-topbar {
  display: flex;
  align-items: center;
  padding: 0 1.5rem;
  background: var(--side-panel);
  border-left: 1px solid var(--border-subtle);
  height: 56px;
  box-sizing: border-box;
  gap: 0.75rem;
}

.fin-topbar__status {
  font-size: 0.85rem;
  color: var(--text-secondary);
}

.fin-topbar__identity {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  flex: 1;
}

.fin-topbar__title {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 0.95rem;
  color: #ffffff;
}

.fin-topbar__subtitle {
  font-family: var(--font-body);
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.6);
}

.fin-topbar__center {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  flex: 1.4;
  justify-content: center;
}

.fin-topbar__compare-btn {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  height: 32px;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 6px;
  color: rgba(255, 255, 255, 0.7);
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.82rem;
  padding: 0 0.7rem;
  cursor: pointer;
  transition: color 0.15s ease, border-color 0.15s ease;
}

.fin-topbar__compare-btn:hover {
  color: rgba(255, 255, 255, 0.9);
}

.fin-topbar__compare-btn--active {
  color: #ffffff;
  border-color: rgba(255, 255, 255, 0.5);
}

.fin-topbar__right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  flex: 1;
}

.fin-topbar__divider {
  width: 1px;
  align-self: stretch;
  background: rgba(255, 255, 255, 0.15);
  flex-shrink: 0;
}

.fin-topbar__report-btn {
  height: 32px;
  background: #ffffff;
  border: none;
  border-radius: 6px;
  color: #1e3a5f;
  font-family: var(--font-body);
  font-weight: 500;
  font-size: 0.82rem;
  padding: 0 0.9rem;
  cursor: pointer;
  white-space: nowrap;
}

.fin-topbar__report-btn:hover {
  background: #f1f5f9;
}

.fin-topbar__spinner {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  animation: fin-spin 0.8s linear infinite;
}

@keyframes fin-spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>